import { useMemo } from 'react';
import { useAuth } from '../../../../app/providers/AuthContext';

export const useRecentActivity = () => {
    const { user } = useAuth();
    const latestActivity = useMemo(() => {
        if (user && user.recentActivities && user.recentActivities.length > 0) {
            return [...user.recentActivities].sort((a, b) =>
                new Date(b.lastAccessed).getTime() - new Date(a.lastAccessed).getTime()
            )[0];
        }
        return null;
    }, [user]);

    const loading = false;

    const getLearningLink = () => {
        if (!latestActivity) return '/courses';

        return `/courses/${latestActivity.courseSlug}/learn`;
    };

    return { latestActivity, loading, getLearningLink };
};
